import Util from 'service/util';

const A4OrderInvoice = ({order, ...props}) => {

  let total = order.items.reduce((r,itm) => r + itm.qty * itm.unit_price - itm.discount, 0);

  const renderRows = () => {
    let elms = order.items.map((itm, idx) =>
      <tr key={idx}>
        <td className="col-oivp-item">{ itm.srv_name }</td>
        <td className="col-oivp-price">
          <div>{ Util.nf(itm.unit_price) }</div>
        </td>
        <td className="col-oivp-qty">{ itm.qty }</td>
        <td className="col-oivp-discount">
          <div>{ Util.nf(itm.discount) }</div>
        </td>
        <td className="col-oivp-total">
          <div>{ Util.nf(itm.qty * itm.unit_price - itm.discount) }</div>
        </td>
      </tr>
    );

    return elms;
  }

  const renderTitle = () =>
  {
    if (order.payment_type != '0') return '收據';
    else return '發票';
  }

  const renderHeader = () =>
  {
    switch (order.company)
    {
      case 'KY': return <>
        <h2>專業汽車護理公司</h2>
        <h4>PROFESSIONAL CAR SERVICES CO.</h4>
        <table>
          <tbody>
            <tr>
              <th>電話</th><td>5546-3735</td>
              <th>傳真</th><td>2413-7263</td>
            </tr>
          </tbody>
        </table>
      </>
      case 'PF': return <>
        <h2>優質汽車護理</h2>
        <h4>TOP ONE CAR SERVICES CO.</h4>
        <div className="info">
          <strong>電話：</strong>
          <div>2402-4138</div>
        </div>
      </>
      default: return <>
        <h2>天記汽車護理服務公司</h2>
        <h4>Tin Kee Car Services Company</h4>
        <table>
          <tbody>
            <tr>
              <th>電話</th><td>2415-1522</td>
              <th>傳真</th><td>2494-8871</td>
            </tr>
          </tbody>
        </table>
      </>
    }
  }

/* <table>
    <tbody>
      <tr>
        <th>電話</th><td>2402-4138</td>
      </tr>
    </tbody>
  </table> */

  const renderPayInfo = () =>
  {
    if (order.payment_type != '0') return '';
    else switch (order.company)
    {
      case 'KY': return <>
        <p><strong>過戶收費方法</strong></p>
        <ol>
          <li>匯豐銀行A/C : 747-127660-001   戶主 : (PROFESSIONAL CAR SERVICES  CO.)；或</li>
          <li>中國銀行A/C : 012-355-104-268-55   戶主 : (Chan kai chung)；或</li>
          <li>轉數快ID : 163028319</li>
        </ol>
        <p>
        過戶後，請在入數紙上填寫車牌號碼，並Fax: 2413-7263 / Whatsapp: 5546-3735 / Email: ckccar@yahoo.com.hk
        </p>

        <p><strong>遞交支票方法</strong></p>
        <p>
        劃線支票抬頭：專業汽車護理公司 / Professional Car Services CO.
        <br/>
        支票背後請寫上車牌號碼及聯絡電話號碼，方便核實。
        </p>
        <p>
        郵寄地址: <strong>荃灣郵政局郵政信箱 1358 號</strong> （收據如要郵寄請註明地址）
        </p>
      </>
      case 'PF': return <>
        <p><strong>過戶收費方法</strong></p>
        <ol>
          <li>恆生賬戶: 924-252950-888 (戶名:陳啟聰)</li>
          <li>中銀賬戶: 012-355-10426855 (戶名:陳啟聰)</li>
        </ol>
        <p>
        過戶後請將入數紙 Whatsapp 至 95777005
        </p>

        <p><strong>遞交支票方法</strong></p>
        <p>
        支票抬頭請寫上: 陳啟聰 / CHAN KAI CHUNG
        <br/>
        支票背後請寫上車牌號碼及聯絡電話號碼，方便核實。
        </p>
      </>
      default: return <>
        <p><strong>過戶收費方法</strong></p>
        <ol>
          <li>匯豐銀行A/C : 032-894149-001   戶主 : (TIN KEE CAR SERVICES CO.)；或</li>
          <li>中國銀行A/C : 033-655-000-33239   戶主 : (TIN KEE INTERNATIONAL LTD.)；或</li>
          <li>轉數快ID : 163596406</li>
        </ol>

        <p>
        過戶後，請在入數紙上填寫車牌號碼，並FAX: 2494-8871 / Whatsapp: 9606-6162 / Email: TinKeeCar@yahoo.com.hk
        </p>

        <p><strong>遞交支票方法</strong></p>
        <p>
        劃線支票抬頭：天記汽車護理服務公司 / Tin Kee Car Services CO
        <br />
        支票背後請寫上車牌號碼及聯絡電話號碼，方便核實。
        </p>
        <p>
        郵寄地址: <strong>荃灣郵政局郵政信箱 1256 號</strong>（收據如要郵寄請註明地址）
        </p>
      </>
    }
  }

  return (
    <div className="page">
      <section className="oiv-header">
        { renderHeader() }
        <hr/>
        <h1>{ renderTitle() }</h1>
      </section>
      <section className="oiv-info">
        <div className="grid">
          <strong>客戶資料</strong>
          <strong>訂單資料</strong>
          <table>
            <tbody>
              <tr>
                <th>客戶編號</th>
                <td>{ order.cust_id }</td>
              </tr>
              <tr>
                <th>名稱</th>
                <td>{ order.cust_name }</td>
              </tr>
              <tr>
                <th>車牌</th>
                <td>{ order.cd_license }</td>
              </tr>
              <tr>
                <th>車場</th>
                <td>{ order.srv_dis }{ order.srv_loc } - { order.name_zh }</td>
              </tr>
              <tr>
                <th>車位</th>
                <td>{ order.srv_floor } { order.srv_psn}</td>
              </tr>
              <tr>
                <th>地址</th>
                <td>{ order.srv_addr }</td>
              </tr>
            </tbody>
          </table>
          <table className="right">
            <tbody>
              <tr>
                <th>訂單編號</th>
                <td>{ order.ix_yrmo}-{ Util.LPAD(order.id, 7) }</td>
              </tr>
              <tr>
                <th>建單日期</th>
                <td>{ Util.FullDate(order.create_dtm) }</td>
              </tr>
              <tr>
                <th>下單日期</th>
                <td>{ Util.ShortDate(order.order_dtm) }</td>
              </tr>
              <tr>
                <th>負責同事</th>
                <td>{ order.create_by }</td>
              </tr>
              <tr>
                <th>訂單狀態</th>
                <td>{ Util.getOrderStatus(order.o_status) }</td>
              </tr>
              <tr>
                <th>付款模式</th>
                <td>{ Util.getPaymentType(order.payment_type) }</td>
              </tr>
              <tr>
                <th>金額</th>
                <td>$ { Util.nf2(order.payment_amount) }</td>
              </tr>
              <tr>
                <th>參考編號</th>
                <td>{ order.payment_ref }</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section className="oiv-items">
        <table>
          <colgroup>
            <col width="auto" />
            <col width="80mm" />
            <col width="80mm" />
            <col width="80mm" />
            <col width="80mm" />
          </colgroup>
          <thead>
            <tr>
              <th>項目</th>
              <th>單價</th>
              <th>數量</th>
              <th>折扣</th>
              <th>金額</th>
            </tr>
          </thead>
          <tbody>
            { renderRows() }
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <th className="right">總計</th>
              <th className="col-oivp-grand-total"><div>{ total }</div></th>
            </tr>
          </tfoot>
        </table>
      </section>
      <section className="oiv-payinfo">
        { renderPayInfo() }
      </section>
    </div>
  );
}

export default A4OrderInvoice;